import React from "react";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { formatBytes } from "../utils/dtos";

const VaultDocument = ({ item }) => {
  return (
    <div className="border-2 py-5 px-5 rounded-xl mt-2">
      <p className="text-base font-medium pb-5 capitalize">{item?.documentName?.split(".")[0]}</p>
      <p className="text-sm">
        <span className="font-semibold">Uploaded on:</span> {new Date(item?.uploadDate.seconds).toUTCString()}
      </p>
      <p className="text-sm mt-2 pb-5">
        <span className="font-semibold">File size:</span> {formatBytes(item?.fileSize)}
      </p>
      <div className="flex justify-between items-center">
        <p className="text-sm font-medium text-primary">{item?.documentName}</p>
        <a
          href={item?.downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center text-primary border-2 border-primary hover:bg-primary hover:text-white py-2 px-5 rounded cursor-pointer"
        >
          <FaCloudDownloadAlt className="text-xl" />
          <p className="text-sm pl-3">Open</p>
        </a>
      </div>
    </div>
  );
};

export default VaultDocument;
